export enum FlyoutSearchView {
  Desktop = 'desktop',
  Mobile = 'mobile'
}

export enum FlyoutTrackerView {
  Desktop = 'desktop',
  Mobile = 'mobile'
}
